import { mediaSkeleton } from '../../../../widgets/plug/Skeleton/components/patterns';

export const userInfoSkeleton = (breakpoint) => {
    return [
        {
            row: [70, 10, 20],
            items: [
                {
                    row: [35, 65],
                    gap: 2,
                    items: [
                        {
                            type: 'circle',
                            diameter: mediaSkeleton(breakpoint, { 768: 10 }, 5)
                        },
                        {
                            content: [
                                {
                                    type: 'text',
                                    width: 40
                                },
                                {
                                    type: 'title',
                                    width: 60
                                },
                                'empty',
                                {
                                    type: 'blockSM'
                                }
                            ]
                        }
                    ]
                },
                'empty',
                'blockSM'
            ],
            gap: 10,
            vertical: 'unset'
        },
        'empty',
        'empty',
        {
            row: [25, 25, 25, 25],
            items: ['blockXL', 'blockXL', 'blockXL', 'blockXL'],
            gap: 2
        }
    ];
};
